import {
  commonCiEnv,
  commonDevEnv,
  InjectableConfig,
  WindowedObservable,
} from '@procom-labs/common'

const dev = {
  ...commonDevEnv,
  GTM_KEY: process.env.GTM_KEY || 'GTM-5JVF36B',
  rollbar: {
    captureUncaught: process.env.ROLLBAR_CAPTURE_UNCAUGHT
      ? process.env.ROLLBAR_CAPTURE_UNCAUGHT === 'true'
      : false,
    captureUnhandledRejections: process.env.ROLLBAR_CAPTURE_UNHANDLED
      ? process.env.ROLLBAR_CAPTURE_UNHANDLED === 'true'
      : false,
    accessToken: process.env.ROLLBAR_ACCESS_TOKEN || '123',
    enabled: process.env.ROLLBAR_ENABLED || 'false',
    payload: {
      environment: process.env.ROLLBAR_ENVIRONMENT || 'local',
    },
  },
  GOOGLE_RECAPTCHA_KEY:
    process.env.GOOGLE_RECAPTCHA_KEY ||
    '6Le7yUMoAAAAAJNa8h71NPySvz2lyd_zNhM7JQvm',
  BLOB_STORAGE_URL:
    process.env.BLOB_STORAGE_URL ||
    'https://procomstoragedev.blob.core.windows.net',
  MAP_FBO_USER_SERVICE_API_ID:
    process.env.MAP_FBO_USER_SERVICE_API_ID || '104746405f46cc651e33',
  MAP_FBO_USER_SERVICE_API_KEY:
    process.env.MAP_FBO_USER_SERVICE_API_KEY ||
    'd65eccdd567b1f35c2d9d54bfe6a6d6046ef6d2d72dcc5cefa5ecf772889f04a7f8a0895a9d4ef88',
  MAP_FBO_USER_SERVICE_BASE_URL:
    process.env.MAP_FBO_USER_SERVICE_BASE_URL || 'https://localhost:5001/',
  ENABLE_CONTRACTOR_LOGIN: process.env.ENABLE_CONTRACTOR_LOGIN || 'true',
  ENABLE_CLIENT_PORTAL_SIGNUP:
    process.env.ENABLE_CLIENT_PORTAL_SIGNUP || 'true',
  EY_DEMO_USER: 'alessandra.willsher@procom.ca',
  EY_DEMO_LOGO: 'true',
  EY_CONTRACTOR_MANAGEMENT_URL:
    'https://app.gorillaworks.io/version-514vb/contractor_management',
  MS_SSO_CLIENT_ID:
    process.env.MS_SSO_CLIENT_ID || 'b419c7a0-6145-4863-b254-d5de62677e2f',
  MS_SSO_AUTHORITY:
    process.env.MS_SSO_AUTHORITY || 'https://login.microsoftonline.com/common',
  IS_FBO_INVITATION_SIGNUP_MAINTENANCE_ENABLED: process.env.IS_FBO_INVITATION_SIGNUP_MAINTENANCE_ENABLED ?? 'false',
}

const ci = {
  ...commonCiEnv,
  GTM_KEY: '#{GTM_KEY}#',
  rollbar: {
    accessToken: '#{Rollbar.FrontEndAccessToken}#',
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: '#{Rollbar.FrontEndEnabled}#',
    payload: {
      environment: '#{Rollbar.Environment}#',
    },
  },
  GOOGLE_RECAPTCHA_KEY: '#{GOOGLE_RECAPTCHA_KEY}#',
  BLOB_STORAGE_URL: '#{BLOB_STORAGE_URL}#',
  MAP_FBO_USER_SERVICE_API_ID: '#{MAP_FBO_USER_SERVICE_API_ID}#',
  MAP_FBO_USER_SERVICE_API_KEY: '#{MAP_FBO_USER_SERVICE_API_KEY}#',
  MAP_FBO_USER_SERVICE_BASE_URL: '#{MAP_FBO_USER_SERVICE_BASE_URL}#',
  ENABLE_CONTRACTOR_LOGIN: '#{ENABLE_CONTRACTOR_LOGIN}#',
  ENABLE_CLIENT_PORTAL_SIGNUP: '#{ENABLE_CLIENT_PORTAL_SIGNUP}#',
  EY_DEMO_USER: '#{EY_DEMO_USER}#',
  EY_DEMO_LOGO: '#{EY_DEMO_LOGO}#',
  EY_CONTRACTOR_MANAGEMENT_URL: '#{EY_CONTRACTOR_MANAGEMENT_URL}#',
  MS_SSO_CLIENT_ID: '#{MS_SSO_CLIENT_ID}#',
  MS_SSO_AUTHORITY: '#{MS_SSO_AUTHORITY}#',
  IS_FBO_INVITATION_SIGNUP_MAINTENANCE_ENABLED: '#{IS_FBO_INVITATION_SIGNUP_MAINTENANCE_ENABLED}#',
}
export const environment = {
  ...(process.env.REACT_APP_STAGE === 'ci' ? ci : dev),
}

new WindowedObservable(InjectableConfig.Environment).publish(environment)
